import React from 'react'
import { PartnersList } from './list/page'

export const AnniversaryContestPartnersPage = () => {
  return <PartnersList />
}
